import type { CanBuilder, DefineAbilityForUser } from "../types";
import { defineSojurRules } from "../attributions/sojur";
import { defineEticoRules } from "../attributions/etico";
import { defineEticiRules } from "../attributions/etici";
import { defineComitRules } from "../attributions/comit";

export function defineAdminRules({
	can,
	user,
}: {
	can: CanBuilder;
	user: DefineAbilityForUser;
}): void {
	can("read", "User");
	can("create", "User");
	can("update", "User");
	can("read", "Organization");
	can("read", "Application");
	can("read", "AIAQuestionnaire");
	can("read", "EPSQuestionnaire");

	can("create", "Area");
	can("update", "Area");
	can("delete", "Area");

	defineSojurRules(can);
	defineEticoRules(can);
	defineEticiRules({ can, user }); // user.role === "admin" → no eticistId restriction on evaluate
	defineComitRules(can);
}
